import { render, staticRenderFns } from "./CreatorPaidShareIndex.vue?vue&type=template&id=47846da9&"
import script from "./CreatorPaidShareIndex.vue?vue&type=script&lang=js&"
export * from "./CreatorPaidShareIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports